/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamAdmTrasaWorkflow extends GContentBase<SeznamAdmTrasaWorkflowObj> {
        private seznamObj: SeznamAdmTrasaWorkflowObj & GContent;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamAdmTrasaWorkflowObj());
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamAdmTrasaWorkflowNew",
                contentCaption: "jres:33000795", //RC 33000795 : Trasy dokument�
                dataListDescriptor: this.dataListDescription,
                comparatorSettings: {
                    itemTemplate: "{ixs_tra}"
                },
                gridSettings: {
                    columnOrder: "nazev,poznamka,ixs_tra,priz_pov,priz_pov_porad,priz_edit,dat_zmena,zmenu_prov_txt"
                }
            })
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();
        }
    }

    export class SeznamAdmTrasaWorkflowObj extends GAdmSeznamBase {

        create() {

        }

        openDetail(data: any, isNew: boolean) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailAdmTrasaWorkflow", {
                currentFilter: this.filterData,
                gridRc: new Gordic.Components.GridRC(this.grid)
            }], {
                ID: "DetailAdmTrasaWorkflow",
                newRecord: isNew,
                ixs_tra: isNew == true ? null : data.ixs_tra
            })
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return {
                actOpenAdmKrokyTrasy: {
                    caption: "jres:33000799", //RC 33000799 : Kroky trasy
                    icon: "fa-link",
                    run: (ev, ctx) => {
                        this.openAdmKrokyTrasy();
                    }
                },
                actOpenAdmTrasaProTypDokumentu: {
                    caption: "jres:33000831",
                    icon: "fa-link",
                    run: (ev, ctx) => {
                        this.openAdmTrasaProTypDokumentu();
                    }
                },
                actPriraditHromadneTrasyTypumDokumentu: {
                    caption: "jres:33000837", //RC 33000837 : P�i�adit hromadn� typy dokument�
                    icon: "fa-link",
                    run: (ev, ctx) => {
                        this.priraditHromadneTrasyTypumDokumentu();
                    }
                }
            }
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar(["actOpenDetail*", "actNewDetail*", "actAddToComparison*", "actOpenDialogVyberovaSkupina*", {
                favorite: true, type: "static", caption: "jres:33000138", icon: "fa-link", children: [
                    { action: this.cnt.actions.actOpenAdmKrokyTrasy },
                    { action: this.cnt.actions.actOpenAdmTrasaProTypDokumentu },
                    { action: this.cnt.actions.actPriraditHromadneTrasyTypumDokumentu }
                ]}
            ]))
        }

        createContextMenu(): MenuParams[] {
            return this.cnt.actions.createBar([
                "actOpenDetail*",
                "actOpenDialogVyberovaSkupina*",
                "actOpenAdmKrokyTrasy*",
                "actOpenAdmTrasaProTypDokumentu*"
            ])
        }

        createFilterForm() {
           
        }

        userhardDefaultFilter(hardFilter: any): any {
            return hardFilter;
        }

        collectData(data: any) {
            
        }

        applydata(filterData: any) {
            this.cnt.isl.AdmTrasaWorkflow.list({ filters: filterData }).getView().done((data) => {
                this.view = data;
                this.grid.ggrid('setData', this.view);
            });
        }

        selectionGridAct(objArr: IGGridSelection<any>) {
            this.cnt.actions.actOpenAdmKrokyTrasy?.update({ enabled: objArr.count == 1 })
            this.cnt.actions.actOpenAdmTrasaProTypDokumentu?.update({ enabled: objArr.count == 1 })
            this.cnt.actions.actPriraditHromadneTrasyTypumDokumentu?.update({ enabled: objArr.count > 0 })
        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: `${data.ixs_tra}`,
                nazev: data["nazev"]
            }
        }

        private openAdmKrokyTrasy() {
            var activeRow = this.grid.ggrid("activeRow")
            if (activeRow)
                $.content().navigate(["Gordic.Adm.WebControls.SeznamAdmKrokTrasy", {
                    ixs_tra: activeRow.ixs_tra
                }])
        }

        private openAdmTrasaProTypDokumentu() {
            var activeRow = this.grid.ggrid("activeRow")
            if (activeRow)
                $.content().navigate(["Gordic.Adm.WebControls.SeznamAdmTrasaProTypDokumentu", {
                    ixs_tra: activeRow.ixs_tra
                }])
        }

        private priraditHromadneTrasyTypumDokumentu() {
            var selection = this.grid.ggrid("getSelection");
            var data: Gordic.AdmIsl.Interface.GAdmTrasaProTypDokumentuReadDto[] = [];
            if (selection.length > 0) {
                selection.forEach((item) => {
                    data.push({
                        ixs_tra: item["ixs_tra"]
                    })
                })
            }
            this.cnt.dialogs.showModalWindow(["Gordic.Adm.WebControls.HromadnaOperaceAdmTrasaProTypDokumentu"], { ID: "HromadnaOperaceAdmTrasaProTypDokumentu", data: data }, "", 1000, 600)
        }
    }
}